module.exports = __webpack_public_path__ + "img/smile.652820b4.svg";